// Mock responses data
export const mockResponses = [
  {
    id: "resp-1",
    review_id: "rev-1",
    generated_text: "Добрый день!\n\nБлагодарим Вас за оставленный отзыв! Мы очень рады, что наша тушь для ресниц Volume вам понравилась.\n\nС любовью, команда Art-Visage!",
    final_text: null,
    was_edited: false,
    rag_sources: [
      {
        doc_id: "products/mascara_volume.md",
        chunk_id: "chunk-1",
        score: 0.95
      },
      {
        doc_id: "tone_of_voice/positive_thanks.md",
        chunk_id: "chunk-3",
        score: 0.88
      }
    ],
    rag_confidence: 0.92,
    llm_model: "claude-3-5-sonnet-20241022",
    strategy_id: "strat-5",
    status: "published",
    moderator_id: "user-1",
    moderator_email: "operator@artvisage.ru",
    moderation_notes: null,
    send_after: null,
    published_at: "2025-10-25T11:00:00Z",
    publish_error: null,
    publish_attempts: 1,
    created_at: "2025-10-25T10:40:00Z",
    updated_at: "2025-10-25T11:00:00Z",
  },
  {
    id: "resp-2",
    review_id: "rev-2",
    generated_text: "Добрый день!\n\nБлагодарим за отзыв. Нам очень жаль, что тушь не оправдала ваших ожиданий.\n\nПо вопросу возврата рекомендуем обратиться в службу поддержки маркетплейса - они помогут оформить возврат согласно правилам площадки.\n\nМы ценим ваше мнение и учтем его для улучшения качества продукции.\n\nС уважением, команда Art-Visage",
    final_text: "Добрый день!\n\nБлагодарим за отзыв и сожалеем, что тушь не оправдала ожиданий.\n\nПо вопросу возврата рекомендуем обратиться в службу поддержки Wildberries - они помогут оформить возврат.\n\nМы ценим ваше мнение и учтем его для улучшения качества.\n\nС уважением, Art-Visage",
    was_edited: true,
    rag_sources: [
      {
        doc_id: "faq/returns.md",
        chunk_id: "chunk-5",
        score: 0.91
      },
      {
        doc_id: "tone_of_voice/negative_empathy.md",
        chunk_id: "chunk-2",
        score: 0.85
      }
    ],
    rag_confidence: 0.88,
    llm_model: "claude-3-5-sonnet-20241022",
    strategy_id: "strat-2",
    status: "approved",
    moderator_id: "user-1",
    moderator_email: "operator@artvisage.ru",
    moderation_notes: "Убрал упоминание маркетплейса, сделал короче",
    send_after: null,
    published_at: null,
    publish_error: null,
    publish_attempts: 0,
    created_at: "2025-10-26T14:30:00Z",
    updated_at: "2025-10-26T15:10:00Z",
  },
  {
    id: "resp-3",
    review_id: "rev-4",
    generated_text: "Добрый день!\n\nСпасибо за интерес к нашему тональному крему!\n\nДля светлой кожи рекомендуем оттенки №01 (фарфоровый) или №02 (натуральный беж). Оба оттенка имеют легкую текстуру и естественный финиш.\n\nЕсли у вас очень светлая кожа с холодным подтоном - выбирайте №01, если нейтральный или теплый подтон - №02.\n\nБудем рады видеть вас среди наших покупателей!\n\nС любовью, команда Estrade",
    final_text: null,
    was_edited: false,
    rag_sources: [
      {
        doc_id: "products/foundation_shades.md",
        chunk_id: "chunk-7",
        score: 0.94
      },
      {
        doc_id: "faq/shade_selection.md",
        chunk_id: "chunk-2",
        score: 0.90
      }
    ],
    rag_confidence: 0.92,
    llm_model: "claude-3-5-sonnet-20241022",
    strategy_id: "strat-4",
    status: "draft",
    moderator_id: null,
    moderator_email: null,
    moderation_notes: null,
    send_after: null,
    published_at: null,
    publish_error: null,
    publish_attempts: 0,
    created_at: "2025-10-28T11:50:00Z",
    updated_at: "2025-10-28T11:50:00Z",
  },
  {
    id: "resp-4",
    review_id: "rev-5",
    generated_text: "Добрый день!\n\nБлагодарим за подробный отзыв! Рады, что цвет и стойкость помады вам понравились.\n\nОтносительно небольшой сухости - рекомендуем наносить под помаду увлажняющий бальзам или использовать нашу линейку ухаживающих помад с маслами.\n\nБудем рады видеть вас снова!\n\nС любовью, Art-Visage",
    final_text: null,
    was_edited: false,
    rag_sources: [
      {
        doc_id: "products/lipstick_care.md",
        chunk_id: "chunk-3",
        score: 0.89
      }
    ],
    rag_confidence: 0.85,
    llm_model: "claude-3-5-sonnet-20241022",
    strategy_id: "strat-6",
    status: "published",
    moderator_id: "user-1",
    moderator_email: "operator@artvisage.ru",
    moderation_notes: null,
    send_after: null,
    published_at: "2025-10-29T17:00:00Z",
    publish_error: null,
    publish_attempts: 1,
    created_at: "2025-10-29T16:40:00Z",
    updated_at: "2025-10-29T17:00:00Z",
  },
  {
    id: "resp-5",
    review_id: "rev-6",
    generated_text: "Добрый день! Благодарим за оценку. Рады, что вы выбрали наш товар! С любовью, Art-Visage!",
    final_text: null,
    was_edited: false,
    rag_sources: [],
    rag_confidence: null,
    llm_model: null,
    strategy_id: "strat-5",
    status: "published",
    moderator_id: "user-1",
    moderator_email: "operator@artvisage.ru",
    moderation_notes: "Автоматический шаблон для 5 звезд без текста",
    send_after: null,
    published_at: "2025-10-30T08:30:00Z",
    publish_error: null,
    publish_attempts: 1,
    created_at: "2025-10-30T08:25:00Z",
    updated_at: "2025-10-30T08:30:00Z",
  },
];
